/**
 * External Dependencies
 */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Internal Dependencies
 */
import AsyncComponent from '../../../../components/async-component';
import PageContent from '../../../../components/page-content';
import PageTitle from '../../../../components/page-title';
import PageWrap from '../../../../components/page-wrap';

/**
 * Component
 */
const Error = () => {
  const [title, setTitle] = useState('Caricamento...');
  const navigate = useNavigate();
  const { totem: totemId } = useParams();

  useEffect(() => {
    if (totemId === undefined) {
      navigate('/');
      return;
    }

    window.api.totem
      .pageError(totemId)
      .then(res => {
        const page = res.data.pageError;
        setTitle(page.titolo);
      })
      .catch(() => {
        // navigate('/');
      });
  }, [totemId, navigate]);

  return (
    <PageWrap>
      <PageTitle>
        <h1 id="page-title">{title}</h1>
      </PageTitle>
      <PageContent>
        <AsyncComponent component={() => import('./content')} />
      </PageContent>
    </PageWrap>
  );
};

export default Error;
